import { FunctionComponent } from 'react';

import Modal from 'components/layout/Modal';
import FormUserPhoneLogin from 'components/modules/panel/forms/user/PhoneLogin';

import StyledComponent from './styles';
import { Props } from './types';

const PanelModelsPhoneLoginModal: FunctionComponent<Props> = ({ modalProps }) => {
    return (
        <StyledComponent className="panel-models-phone-login-modal">
            <Modal
                zIndex
                {...modalProps}
            >
                <FormUserPhoneLogin
                    modalClose={modalProps.onClose}
                    phoneNumber={modalProps?.phoneNumber}
                    onSuccess={modalProps?.onSuccess}
                />
            </Modal>
        </StyledComponent>
    );
};

export default PanelModelsPhoneLoginModal;
